import type { CSSProperties, FocusEvent, ChangeEvent } from 'react';
import { FormControl, InputGroup, Spinner } from 'react-bootstrap';

interface BayFieldSpinnerProps {
	id?: string;
	name?: string;
	placeholder?: string;
	value?: string;
	onChangeFunc?: (_e: ChangeEvent<HTMLInputElement>) => void;
	onBlurFunc?: (_e: FocusEvent<HTMLInputElement>) => void;
	isInvalid?: boolean;
	disabled?: boolean;
	isFieldLoading?: boolean;
	maxLength?: number;
	style?: CSSProperties;
	[key: string]: any;
}

const BayFieldSpinner = ({
	id,
	name,
	placeholder,
	value,
	onChangeFunc,
	onBlurFunc,
	isInvalid,
	disabled,
	isFieldLoading,
	maxLength,
	style,
	...otherProps
}: BayFieldSpinnerProps) => {
	return (
		<InputGroup>
			<FormControl
				className={` ${isFieldLoading && 'border-end-0'} testfield`}
				disabled={disabled || isFieldLoading}
				id={id}
				isInvalid={isInvalid}
				maxLength={maxLength}
				name={name}
				placeholder={placeholder}
				style={style}
				type="text"
				value={value}
				onBlur={(e) => onBlurFunc?.(e)}
				onChange={(e) => onChangeFunc?.(e)}
				{...otherProps}
			/>
			{isFieldLoading && (
				<InputGroup.Text className="border-start-0 bg-white">
					<Spinner size="sm" variant="secondary" />
				</InputGroup.Text>
			)}
		</InputGroup>
	);
};

export default BayFieldSpinner;
